import {FC, useState, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {useNavigate} from 'react-router-dom'
import HTMLRenderer from 'react-html-renderer'

const api = new Api()

type Props = {
  showModal: boolean
  handleShowModal: (show: boolean) => void
  temaId: string | null
}

const TemaEssayModal: FC<Props> = ({showModal, handleShowModal, temaId}) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const [temaDetail, setTemaDetail] = useState<any>(null)

  const getTemaDetail = () => {
    if (!temaId) return
    
    setLoading(true)
    api
      .getTemaEssayDetail(temaId)
      .then((response: any) => {
        setLoading(false)
        // Response structure: { meta: {...}, data: {...} }
        const data = response?.data?.data || response?.data
        setTemaDetail(data)
      })
      .catch((error: any) => {
        setLoading(false)
        handleApiError(error, navigate)
      })
  }

  useEffect(() => {
    if (showModal && temaId) {
      getTemaDetail()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal, temaId])

  const handleClose = () => {
    handleShowModal(false)
    setTemaDetail(null)
  }

  return (
    <Modal show={showModal} centered size='lg' onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Detail Tema Essay</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className='text-center py-5'>
            <div className='spinner-border text-primary' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : temaDetail ? (
          <div className='p-3'>
            <div className='mb-4'>
              <h5 className='fw-bold text-dark mb-3'>{temaDetail.title || temaDetail.nama || temaDetail.judul}</h5>
            </div>

            {temaDetail.description && (
              <div className='mb-4'>
                <h6 className='fw-bold text-dark mb-2'>Deskripsi:</h6>
                <div style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', background: '#f5f5f5', padding: '15px', borderRadius: '5px', fontSize: '14px', fontFamily: 'inherit', lineHeight: '1.6', color: '#3F4254'}}>
                  {temaDetail.description}
                </div>
              </div>
            )}

            {temaDetail.deskripsi && (
              <div className='mb-4'>
                <h6 className='fw-bold text-dark mb-2'>Deskripsi:</h6>
                <div style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', background: '#f5f5f5', padding: '15px', borderRadius: '5px', fontSize: '14px', fontFamily: 'inherit', lineHeight: '1.6', color: '#3F4254'}}>
                  {temaDetail.deskripsi}
                </div>
              </div>
            )}

            {temaDetail.criteria && (
              <div className='mb-4'>
                <h6 className='fw-bold text-dark mb-2'>Kriteria:</h6>
                <div style={{textAlign: 'justify', lineHeight: '1.6'}}>
                  <HTMLRenderer html={temaDetail.criteria} />
                </div>
              </div>
            )}

            {temaDetail.kriteria && (
              <div className='mb-4'>
                <h6 className='fw-bold text-dark mb-2'>Kriteria:</h6>
                <div style={{textAlign: 'justify', lineHeight: '1.6'}}>
                  <HTMLRenderer html={temaDetail.kriteria} />
                </div>
              </div>
            )}

            {temaDetail.purpose && (
              <div className='mb-4'>
                <h6 className='fw-bold text-dark mb-2'>Tujuan:</h6>
                <div style={{textAlign: 'justify', lineHeight: '1.6'}}>
                  <HTMLRenderer html={temaDetail.purpose} />
                </div>
              </div>
            )}

            {temaDetail.tujuan && (
              <div className='mb-4'>
                <h6 className='fw-bold text-dark mb-2'>Tujuan:</h6>
                <div style={{textAlign: 'justify', lineHeight: '1.6'}}>
                  <HTMLRenderer html={temaDetail.tujuan} />
                </div>
              </div>
            )}

            {temaDetail.indicator && (
              <div className='mb-4'>
                <h6 className='fw-bold text-dark mb-2'>Indikator:</h6>
                <div style={{textAlign: 'justify', lineHeight: '1.6'}}>
                  <HTMLRenderer html={temaDetail.indicator} />
                </div>
              </div>
            )}

            {temaDetail.indikator && (
              <div className='mb-4'>
                <h6 className='fw-bold text-dark mb-2'>Indikator:</h6>
                <div style={{textAlign: 'justify', lineHeight: '1.6'}}>
                  <HTMLRenderer html={temaDetail.indikator} />
                </div>
              </div>
            )}

            {temaDetail.notes && (
              <div className='mb-4'>
                <h6 className='fw-bold text-dark mb-2'>Catatan:</h6>
                <div style={{textAlign: 'justify', lineHeight: '1.6'}}>
                  <HTMLRenderer html={temaDetail.notes} />
                </div>
              </div>
            )}

            {temaDetail.catatan && (
              <div className='mb-4'>
                <h6 className='fw-bold text-dark mb-2'>Catatan:</h6>
                <div style={{textAlign: 'justify', lineHeight: '1.6'}}>
                  <HTMLRenderer html={temaDetail.catatan} />
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className='text-center py-4'>
            <p className='text-muted'>Tidak ada data tema</p>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button className='btn btn-secondary' onClick={handleClose}>
          Tutup
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default TemaEssayModal
